const PERCENT = 100;

export const getPositionPercent = (max: number, current: number): number => {
  const divider = max || -1; // prevent division by zero
  return (current * PERCENT) / divider;
};

const isInRange = (time: number, start: number, end: number): boolean =>
  time >= start && time <= end;

export const getTimeScale = (
  currentTime: number,
  startTime: number,
  endTime: number
): number => {
  const isActiveTime = isInRange(currentTime, startTime, endTime);
  const timeDiff = endTime - startTime;
  const timeDiffWithCurrent = currentTime - startTime;
  const currentScalePercent = isActiveTime ? timeDiffWithCurrent / timeDiff : 0;

  return currentScalePercent;
};

export const positionToMs = (
  max: number,
  position: number,
  trackWidth: number
): number => {
  const percent = (position * PERCENT) / trackWidth;
  return Math.floor(+(percent * (max / PERCENT)));
};
